import env from '@/config/env'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { trpc, queryClient, client } from './config/trpc'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { cookieConsentGiven } from './lib/cookie'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { fingerprintTrpcErrors } from './lib/posthogBeforeSend'
import { installTranslateGuard } from './lib/translateGuard'
import { UserLoginProvider } from './context/userLogin'
import { BrandProvider } from './context/brandContext'
import { ThemeProvider } from './context/themeContext'
import { CookieBanner } from './components/ui/CookieBanner'
import { Toaster } from './components/ui/shadcn/sonner'
import { ErrorBoundary } from './components/error-boundary'
import App from './App'
import './index.css'

installTranslateGuard()

posthog.init('phc_ObkZsIklgDAxFNlb4x2ddbUwPkaDGtNW00GtlCCS2K1', {
  api_host: 'https://ph.getcassi.ai',
  ui_host: 'https://eu.i.posthog.com',
  defaults: '2025-11-30',
  persistence: cookieConsentGiven() === 'yes' ? 'localStorage+cookie' : 'memory',
  opt_out_capturing_by_default: env.MODE !== 'production',
  __add_tracing_headers: [env.VITE_BACKEND_URL],
  before_send: fingerprintTrpcErrors,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <trpc.Provider client={client} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <ThemeProvider>
              <ErrorBoundary>
                <UserLoginProvider>
                  <BrandProvider>
                    <App />
                    <CookieBanner />
                    <Toaster />
                  </BrandProvider>
                </UserLoginProvider>
              </ErrorBoundary>
            </ThemeProvider>
          </BrowserRouter>
          <ReactQueryDevtools initialIsOpen={true} />
        </QueryClientProvider>
      </trpc.Provider>
    </PostHogProvider>
  </StrictMode>,
)
